var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('Facebook'),_c('Stats'),_c('GroupTiles',{attrs:{"groups":_vm.nav_items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }